import { render, staticRenderFns } from "./SCouponpack.vue?vue&type=template&id=506027bf&scoped=true"
import script from "./SCouponpack.vue?vue&type=script&lang=js"
export * from "./SCouponpack.vue?vue&type=script&lang=js"
import style0 from "./SCouponpack.vue?vue&type=style&index=0&id=506027bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506027bf",
  null
  
)

export default component.exports